module.exports = __webpack_public_path__ + "img/5.d646b7d8.png";